export const EVENT_PHYSICAL_CARD_APPEARED = 1;
export const EVENT_CARDS_CHANGED = 3;
export const EVENT_NEW_OPERATION = 2;
// Максимальное количество опросов при неактивной вкладке
export const MAX_HIDDEN_TRIES = 40;
